import { access_control_list_tab, managers_tab } from '../../../../../../views/team/managers';

export default {
  tabs: {
    [managers_tab]: 'Responsables',
    [access_control_list_tab]: "Contrôle d'accès",
  },
};
